import(/* webpackMode: "eager" */ "/home/kehutanan-web/kehutanan-web/src/app/global-error.tsx");
